module.exports = __webpack_public_path__ + "img/19.63ad466d.jpeg";